export const POSITION_OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  /**
   * Время, через которое браузерное API кинет ошибку.
   * Так же время, которое будем ждать, пока не получим координаты при запросе в "Знакомства"/"Поиск" с фильтром "Рядом".
   */
  timeout: 4_000,
  maximumAge: 900_000,
}
